import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const MutasiAngsuran = (periode, data, namaBulan, tahun, jenisTransaksi, kelompok = "Angsuran") => {
  const doc = new jsPDF("landscape");
  const pageWidth = doc.internal.pageSize.getWidth();
  const isAngsuranA = jenisTransaksi === "D";
  const showLayanan = kelompok !== "Germen" && kelompok !== "Jasa";

  const loadImageAsDataURL = (url) =>
    fetch(url)
      .then((res) => res.blob())
      .then((blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
      );

  const namaBulanFinal = namaBulan || "Tidak Diketahui";
  const tahunFinal = tahun || "Tidak Diketahui";
  const judul =
    kelompok === "Germen"
      ? `Laporan Mutasi Germen ${isAngsuranA ? "D" : "C"}`
      : kelompok === "Jasa"
        ? `Laporan Mutasi Jasa Angsuran ${isAngsuranA ? "D" : "C"}`
        : `Laporan Mutasi Angsuran ${isAngsuranA ? "D" : "C"}`;
  const subJudul = `${namaBulanFinal} ${tahunFinal}`;

  const getFieldSet = () => {
    if (kelompok === "Germen") {
      return {
        saldo: isAngsuranA ? "sldgermen_a" : "sldgermen_b",
        trans: isAngsuranA ? "germen_a" : "germen_b",
        layanan: isAngsuranA ? "layanan_a" : "layanan_b",
        saldoLabel: `Saldo Awal ${isAngsuranA ? "D" : "C"}`,
        transLabel: `Germen ${isAngsuranA ? "D" : "C"}`,
        layananLabel: `Layanan ${isAngsuranA ? "D" : "C"}`,
      };
    }

    if (kelompok === "Jasa") {
      return {
        saldo: isAngsuranA ? "sldjasa_a" : "sldjasa_b",
        trans: isAngsuranA ? "jasa_a" : "jasa_b",
        layanan: isAngsuranA ? "layanan_a" : "layanan_b",
        saldoLabel: `Saldo Awal ${isAngsuranA ? "D" : "C"}`,
        transLabel: `Jasa ${isAngsuranA ? "D" : "C"}`,
        layananLabel: `Layanan ${isAngsuranA ? "D" : "C"}`,
      };
    }

    return {
      saldo: isAngsuranA ? "sldawal_ua" : "sldawal_ub",
      trans: isAngsuranA ? "angsur_a" : "angsur_b",
      layanan: isAngsuranA ? "layanan_a" : "layanan_b",
      saldoLabel: `Saldo Awal ${isAngsuranA ? "D" : "C"}`,
      transLabel: `Angsuran ${isAngsuranA ? "D" : "C"}`,
      layananLabel: `Layanan ${isAngsuranA ? "D" : "C"}`,
    };
  };

  const fieldSet = getFieldSet();

  const drawHeader = (logoDataUrl) => {
    const logoX = 10;
    const logoY = 8;
    const logoSize = 18;
    const textX = logoX + logoSize + 3;

    if (logoDataUrl) {
      doc.addImage(logoDataUrl, "PNG", logoX, logoY, logoSize, logoSize);
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("KPRI SRI REJEKI", textX, 15);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 21);

    const lineY = logoY + logoSize + 4;
    doc.setLineWidth(0.5);
    doc.line(10, lineY, pageWidth - 10, lineY);

    const reportY = lineY + 8;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(judul, pageWidth / 2, reportY, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.text(subJudul, pageWidth / 2, reportY + 7, { align: "center" });

    return reportY + 13;
  };

  const headers = showLayanan
    ? [["No", "No Anggota", "Nama", "Kode UK", fieldSet.saldoLabel, fieldSet.transLabel, fieldSet.layananLabel, "Saldo Akhir"]]
    : [["No", "No Anggota", "Nama", "Kode UK", fieldSet.saldoLabel, fieldSet.transLabel, "Saldo Akhir"]];

  const formatNumber = (num) => Number(num || 0).toLocaleString("id-ID");
  let totalSaldoAwal = 0;
  let totalTrans = 0;
  let totalLayanan = 0;
  let totalSaldoAkhir = 0;

  const tableData = data.map((item, index) => {
    const trans = Number(item[fieldSet.trans] || 0);
    const layanan = showLayanan && fieldSet.layanan ? Number(item[fieldSet.layanan] || 0) : 0;

    let saldoAwal;
    let saldoAkhir;

    if (kelompok === "Angsuran") {
      saldoAwal = Number(item[fieldSet.saldo] || 0);
      saldoAkhir = saldoAwal - trans + layanan ;
    } else {
      //Germen/Jasa 
      saldoAkhir = Number(item[fieldSet.saldo] || 0);
      saldoAwal = saldoAkhir - trans;
    }

    totalSaldoAwal += saldoAwal;
    totalTrans += trans;
    totalLayanan += layanan;
    totalSaldoAkhir += saldoAkhir;

    return showLayanan
      ? [
          { content: index + 1, styles: { halign: "center" } },
          { content: item.noanggota || "-", styles: { halign: "center" } },
          { content: item.nama || "-" },
          { content: item.unitkerja || "-" },
          { content: formatNumber(saldoAwal), styles: { halign: "right" } },
          { content: formatNumber(trans), styles: { halign: "right" } },
          { content: formatNumber(layanan), styles: { halign: "right" } },
          { content: formatNumber(saldoAkhir), styles: { halign: "right" } },
        ]
      : [
          { content: index + 1, styles: { halign: "center" } },
          { content: item.noanggota || "-", styles: { halign: "center" } },
          { content: item.nama || "-" },
          { content: item.unitkerja || "-" },
          { content: formatNumber(saldoAwal), styles: { halign: "right" } },
          { content: formatNumber(trans), styles: { halign: "right" } },
          { content: formatNumber(saldoAkhir), styles: { halign: "right" } },
        ];
  });

  tableData.push(
    showLayanan
      ? [
          { content: "", styles: { halign: "center" } },
          { content: "TOTAL", colSpan: 3, styles: { fontSize: 8, halign: "center", fontStyle: "bold" } },
          { content: formatNumber(totalSaldoAwal), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
          { content: formatNumber(totalTrans), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
          { content: formatNumber(totalLayanan), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
          { content: formatNumber(totalSaldoAkhir), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
        ]
      : [
          { content: "", styles: { halign: "center" } },
          { content: "TOTAL", colSpan: 3, styles: { fontSize: 8, halign: "center", fontStyle: "bold" } },
          { content: formatNumber(totalSaldoAwal), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
          { content: formatNumber(totalTrans), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
          { content: formatNumber(totalSaldoAkhir), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
        ]
  );

  const renderTable = (startY) => {
    autoTable(doc, {
      head: headers,
      body: tableData,
      startY,
      theme: "grid",
      margin: { left: (pageWidth - 281) / 2, right: (pageWidth - 281) / 2, top: 20, bottom: 10 },
      tableWidth: "wrap",
      headStyles: {
        halign: "center",
        valign: "middle",
        fontSize: 8,
        cellPadding: 2,
        fillColor: [32, 178, 170],
        textColor: 255,
        fontStyle: "bold",
      },
      styles: { fontSize: 8, cellPadding: 1.5, overflow: "linebreak", valign: "middle" },
      showHead: "everyPage",
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: 28, halign: "center" },
        2: { cellWidth: 55, halign: "left" },
        3: { cellWidth: 60, halign: "left" },
        4: { cellWidth: 32, halign: "right" },
        5: { cellWidth: 32, halign: "right" },
        6: { cellWidth: 32, halign: "right" },
        7: { cellWidth: 32, halign: "right" },
      },
      didParseCell: (tableCell) => {
        if (tableCell.row.raw && tableCell.row.raw[1]?.content === "TOTAL") {
          tableCell.cell.styles.fontStyle = "bold";
          tableCell.cell.styles.fillColor = [230, 230, 230];
          if (tableCell.column.index >= 4) tableCell.cell.styles.halign = "right";
        }
      },
      didDrawPage: (pageData) => {
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageData.settings.margin.left, doc.internal.pageSize.height - 8);
      },
    });

    const pdfBlob = doc.output("blob");
    window.open(URL.createObjectURL(pdfBlob), "_blank");
  };

  const customLogoUrl = "/koperasihitamputih.png";
  loadImageAsDataURL(customLogoUrl)
    .then((logoDataUrl) => renderTable(drawHeader(logoDataUrl)))
    .catch(() => renderTable(drawHeader()));
};

export default MutasiAngsuran;

